import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "product-section" };
const _hoisted_5 = { class: "product-image" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "product-details" };
const _hoisted_8 = { class: "product-name" };
const _hoisted_9 = { class: "product-description" };
const _hoisted_10 = { class: "product-price" };
const _hoisted_11 = { class: "size-selection" };
const _hoisted_12 = ["value", "onChange"];
const _hoisted_13 = { class: "ingredients-info" };
const _hoisted_14 = { class: "info-item" };
const _hoisted_15 = { class: "info-item" };
const _hoisted_16 = { class: "info-item" };
const _hoisted_17 = {
    key: 0,
    class: "additional-options-section"
};
const _hoisted_18 = { class: "group-title" };
const _hoisted_19 = { class: "options-hint" };
const _hoisted_20 = { class: "additional-options-list" };
const _hoisted_21 = ["value"];
const _hoisted_22 = { class: "option-name" };
const _hoisted_23 = {
    key: 1,
    class: "base-ingredients-section"
};
const _hoisted_24 = { class: "ingredients-grid" };
const _hoisted_25 = { class: "default-badge" };
const _hoisted_26 = { class: "ingredient-card-image" };
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = { class: "ingredient-name" };
const _hoisted_29 = { class: "ingredient-base-controls" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "ingredients-container" };
const _hoisted_32 = { class: "group-title" };
const _hoisted_33 = { class: "ingredients-grid" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
    key: 0,
    class: "default-badge"
};
const _hoisted_36 = { class: "ingredient-card-image" };
const _hoisted_37 = ["src", "alt"];
const _hoisted_38 = {
    key: 0,
    class: "removed-overlay"
};
const _hoisted_39 = { class: "ingredient-name" };
const _hoisted_40 = {
    key: 1,
    class: "ingredient-price default-price"
};
const _hoisted_41 = {
    key: 2,
    class: "ingredient-price"
};
const _hoisted_42 = { class: "ingredient-controls" };
const _hoisted_43 = ["onClick", "disabled"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "modal-footer" };
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getAllIngredients } from "@/service/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PizzaCustomizationModal',
    props: {
        product: {},
        initialSelectedSize: {}
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const selectedSizeId = ref("");
        const selectedSize = ref(null);
        const quantity = ref(1);
        const customIngredients = ref({});
        const customizeMode = ref("add");
        const removedBaseIngredients = ref(new Set());
        const allIngredients = ref([]);
        const isLoadingIngredients = ref(false);
        const selectedAdditionalOption = ref(null);
        const parseAdditionalOptions = (additionnal) => {
            if (!additionnal)
                return [];
            if (Array.isArray(additionnal)) {
                return additionnal.filter((item) => (typeof item === "string" && item.trim().length > 0) ||
                    (item && typeof item === "object"));
            }
            if (typeof additionnal === "string") {
                const trimmed = additionnal.trim();
                if (!trimmed)
                    return [];
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return parsed.filter((item) => (typeof item === "string" && item.trim().length > 0) ||
                            (item && typeof item === "object"));
                    }
                }
                catch (error) {
                }
            }
            return [];
        };
        const getOptionName = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.name || "";
        };
        const getOptionKey = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.id || option.name;
        };
        const isOptionSelected = (option) => {
            if (!selectedAdditionalOption.value)
                return false;
            // If string
            if (typeof option === "string")
                return selectedAdditionalOption.value === option;
            // If object
            if (typeof selectedAdditionalOption.value === 'object') {
                // Compare IDs if possible
                const selObj = selectedAdditionalOption.value;
                return selObj.id === option.id;
            }
            return false;
        };
        const additionalOptions = computed(() => {
            return parseAdditionalOptions(props.product?.additionnal);
        });
        const formatPrice = (price) => `${price.toFixed(2)} CHF`;
        const getProductDescription = () => {
            if (!props.product?.description)
                return "";
            return props.product.description.replace(/<[^>]*>/g, "").trim();
        };
        const sortedSizes = computed(() => {
            if (!props.product?.sizes)
                return [];
            return [...props.product.sizes].sort((a, b) => {
                const order = ["Petite", "Normale", "Grande"];
                return order.indexOf(a.name) - order.indexOf(b.name);
            });
        });
        const selectSize = (size) => {
            selectedSize.value = size;
            selectedSizeId.value = size.id;
        };
        const mapProductSizeToVariationSize = (productSizeName) => {
            const sizeName = productSizeName?.toLowerCase() || "";
            if (sizeName.includes("grande") || sizeName.includes("large")) {
                return "Grande";
            }
            if (sizeName.includes("normale") || sizeName.includes("normal")) {
                return "Normale";
            }
            return "unique";
        };
        const getIngredientPriceForSize = (ingredient, productSize) => {
            if (!ingredient || !productSize)
                return 0;
            if (ingredient.isDefault === true ||
                ingredient.id?.startsWith("base-")) {
                return 0;
            }
            if (ingredient.price_variations &&
                Array.isArray(ingredient.price_variations)) {
                let variationSize = "unique";
                if (typeof productSize === "object" && productSize.position !== undefined) {
                    // Priority 1: Map based on position
                    const positionMap = {
                        1: "Normale",
                        2: "Petite",
                        3: "Grande"
                    };
                    variationSize = positionMap[productSize.position] || "unique";
                }
                else {
                    // Priority 2: Fallback to name-based mapping
                    const sizeName = typeof productSize === "string" ? productSize : productSize.name;
                    variationSize = mapProductSizeToVariationSize(sizeName || "Normale");
                }
                let priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === variationSize.toLowerCase());
                if (!priceVariation) {
                    if (variationSize === "Grande") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "normale");
                    }
                    else if (variationSize === "Normale") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "unique");
                    }
                }
                if (!priceVariation && ingredient.price_variations.length > 0) {
                    priceVariation = ingredient.price_variations[0];
                }
                if (priceVariation && typeof priceVariation.price === "number") {
                    return priceVariation.price;
                }
            }
            if (ingredient.extra_cost_price !== undefined) {
                return typeof ingredient.extra_cost_price === "number"
                    ? ingredient.extra_cost_price
                    : parseFloat(ingredient.extra_cost_price) || 0;
            }
            if (ingredient.price !== undefined) {
                return typeof ingredient.price === "number"
                    ? ingredient.price
                    : parseFloat(ingredient.price) || 0;
            }
            return 0;
        };
        const baseIngredients = computed(() => {
            if (props.product?.baseIngredients &&
                props.product.baseIngredients.length > 0) {
                return props.product.baseIngredients;
            }
            const product = props.product;
            if (product?.ingredientsBaseNames &&
                product.ingredientsBaseNames.length > 0) {
                const baseIngs = product.ingredientsBaseNames.map((name, index) => ({
                    id: `base-${index}`,
                    name: name,
                    isDefault: true,
                    isAvailable: true,
                    price: 0,
                    image: "/images/ingredients/default.png",
                    imageUrl: "/images/ingredients/default.png",
                }));
                return baseIngs;
            }
            return [];
        });
        const groupedIngredients = computed(() => {
            const groups = {};
            const currentSizeName = selectedSize.value?.name || null;
            const baseIngredientIds = new Set(baseIngredients.value.map((ing) => ing.id));
            allIngredients.value
                .filter((ing) => ing.is_available &&
                !baseIngredientIds.has(ing.id) &&
                !ing.id?.startsWith("base-"))
                .forEach((ing) => {
                const type = ing.type;
                const typePosition = ing.type_position ?? 999;
                if (!groups[type]) {
                    groups[type] = {
                        type,
                        position: typePosition,
                        ingredients: [],
                    };
                }
                const price = getIngredientPriceForSize(ing, selectedSize.value);
                groups[type].ingredients.push({
                    id: ing.id,
                    name: ing.name,
                    imageUrl: ing.image_url,
                    type: ing.type,
                    isAvailable: ing.is_available,
                    isDefault: ing.is_default,
                    price: price,
                    extra_cost_price: price,
                    price_variations: ing.price_variations,
                    pricing: {
                        "24cm": price,
                        "28cm": price,
                        "33cm": price,
                        "40cm": price,
                    },
                });
            });
            const sortedGroups = Object.values(groups).sort((a, b) => a.position - b.position);
            return sortedGroups;
        });
        const getIngredientQuantity = (ingredientId) => {
            return customIngredients.value[ingredientId] || 0;
        };
        const incrementIngredient = (ingredient) => {
            const currentQty = getIngredientQuantity(ingredient.id);
            customIngredients.value[ingredient.id] = (currentQty || 0) + 1;
        };
        const decrementIngredient = (ingredient) => {
            const currentQty = getIngredientQuantity(ingredient.id);
            if (currentQty > 0) {
                customIngredients.value[ingredient.id] = currentQty - 1;
            }
        };
        const toggleIngredient = (ingredient) => {
            const currentQty = getIngredientQuantity(ingredient.id);
            if (customizeMode.value === "add") {
                if (ingredient.isDefault) {
                    customIngredients.value[ingredient.id] = currentQty + 1;
                }
                else {
                    customIngredients.value[ingredient.id] =
                        currentQty > 0 ? currentQty + 1 : 1;
                }
            }
            else {
                if (ingredient.isDefault) {
                    customIngredients.value[ingredient.id] = 0;
                }
                else {
                    customIngredients.value[ingredient.id] = 0;
                }
            }
        };
        const removeBaseIngredient = (ingredient) => {
            if (ingredient) {
                const newSet = new Set(removedBaseIngredients.value);
                newSet.add(ingredient.id);
                removedBaseIngredients.value = newSet;
                delete customIngredients.value[ingredient.id];
            }
        };
        const basePrice = computed(() => {
            if (!selectedSize.value)
                return 0;
            const isDelivery = store.getters["orderType/isDelivery"];
            return isDelivery && selectedSize.value.priceLivraison
                ? parseFloat(selectedSize.value.priceLivraison)
                : parseFloat(selectedSize.value.price);
        });
        const ingredientsPrice = computed(() => {
            let price = 0;
            if (selectedSize.value) {
                const baseIngredientIds = new Set(baseIngredients.value.map((ing) => ing.id));
                for (const ingId in customIngredients.value) {
                    const quantity = customIngredients.value[ingId];
                    if (quantity > 0) {
                        if (baseIngredientIds.has(ingId)) {
                            continue;
                        }
                        let ingredient = props.product?.ingredients?.find((i) => i.id === ingId);
                        if (!ingredient) {
                            ingredient = allIngredients.value.find((i) => i.id === ingId);
                        }
                        if (ingredient && !ingredient.isDefault) {
                            const ingredientPrice = getIngredientPriceForSize(ingredient, selectedSize.value);
                            price += ingredientPrice * quantity;
                        }
                    }
                }
            }
            return price;
        });
        const totalPrice = computed(() => {
            return (basePrice.value + ingredientsPrice.value) * quantity.value;
        });
        const loadIngredients = async () => {
            try {
                isLoadingIngredients.value = true;
                const response = await getAllIngredients(1, 100);
                if (response.code === 200 && response.data?.data) {
                    allIngredients.value = response.data.data;
                }
                else {
                    allIngredients.value = [];
                }
            }
            catch (error) {
                allIngredients.value = [];
            }
            finally {
                isLoadingIngredients.value = false;
            }
        };
        const closeModal = () => {
            selectedAdditionalOption.value = null;
            emit("close");
        };
        const handleAddToCart = () => {
            if (!props.product || !selectedSize.value)
                return;
            const sizeWithOriginalPrices = {
                ...selectedSize.value,
                price: selectedSize.value.price,
                priceLivraison: selectedSize.value.priceLivraison,
            };
            const finalIngredients = [];
            const removedIngredients = [];
            const sizeMap = {
                Petite: "24cm",
                Normale: "33cm",
                Grande: "40cm",
                "Unique (28cm)": "28cm",
            };
            const currentSizeInCm = sizeMap[selectedSize.value.name] || "33cm";
            if (baseIngredients.value.length > 0) {
                removedBaseIngredients.value.forEach((removedId) => {
                    const removedIngredient = baseIngredients.value.find((ing) => ing.id === removedId);
                    if (removedIngredient) {
                        removedIngredients.push({
                            id: removedIngredient.id,
                            name: removedIngredient.name,
                            extra_cost_price: 0,
                            quantity: 1,
                            isDefault: true,
                            size: currentSizeInCm,
                        });
                    }
                });
            }
            Object.entries(customIngredients.value)
                .filter(([id, quantity]) => {
                return quantity > 0 && !id.startsWith("base-");
            })
                .forEach(([id, quantity]) => {
                let ingredientInfo = props.product.ingredients?.find((i) => i.id === id);
                if (!ingredientInfo) {
                    ingredientInfo = allIngredients.value.find((i) => i.id === id);
                }
                let extraCostPrice = 0;
                if (ingredientInfo) {
                    extraCostPrice = getIngredientPriceForSize(ingredientInfo, selectedSize.value);
                }
                finalIngredients.push({
                    id: ingredientInfo?.id || id,
                    name: ingredientInfo?.name || t('pos.unknownIngredient'),
                    extra_cost_price: extraCostPrice,
                    quantity,
                    isDefault: ingredientInfo?.isDefault || false,
                    size: currentSizeInCm,
                });
            });
            const event = {
                product: props.product,
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: finalIngredients,
                removedIngredients: removedIngredients,
                supplements: [],
                additionnal: selectedAdditionalOption.value
                    ? [selectedAdditionalOption.value]
                    : [],
                notes: "",
            };
            emit("add-to-cart", event);
            closeModal();
        };
        watch(() => props.product, async (newProduct) => {
            if (newProduct) {
                selectedAdditionalOption.value = null;
            }
            if (newProduct?.sizes) {
                if (props.initialSelectedSize) {
                    selectSize(props.initialSelectedSize);
                }
                else {
                    const preferredSize = newProduct.sizes.find((s) => s.name === "Normale" ||
                        s.name === "0,5L" ||
                        s.name === "0.5L" ||
                        s.name?.toLowerCase().includes("normale") ||
                        s.name?.toLowerCase().includes("0.5"));
                    const sizeToUse = preferredSize ||
                        newProduct.sizes[Math.floor(newProduct.sizes.length / 2)];
                    if (sizeToUse) {
                        selectSize(sizeToUse);
                    }
                }
            }
            await loadIngredients();
            const defaultIngredients = {};
            if (newProduct?.ingredients && newProduct.ingredients.length > 0) {
                newProduct.ingredients.forEach((ing) => {
                    if (ing.isDefault && !ing.id.startsWith("base-")) {
                        defaultIngredients[ing.id] = 1;
                    }
                });
            }
            else {
                allIngredients.value.forEach((ing) => {
                    if (ing.is_default) {
                        defaultIngredients[ing.id] = 1;
                    }
                });
            }
            customIngredients.value = defaultIngredients;
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (__props.product)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-content",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('pos.customizeProduct')), 1),
                            _createElementVNode("button", {
                                onClick: closeModal,
                                class: "close-button"
                            }, [...(_cache[3] || (_cache[3] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: __props.product.image || '/images/default-product.jpg',
                                        alt: __props.product.name
                                    }, null, 8, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.product.name), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(getProductDescription()), 1),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(formatPrice(basePrice.value)), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSizes.value, (size) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                        key: size.id,
                                        class: _normalizeClass(["size-option", { selected: selectedSize.value?.id === size.id }])
                                    }, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            value: size.id,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSizeId).value = $event)),
                                            onChange: ($event) => (selectSize(size))
                                        }, null, 40, _hoisted_12), [
                                            [_vModelRadio, selectedSizeId.value]
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(size.name), 1)
                                    ], 2));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", {
                                        class: "fas fa-check-circle",
                                        style: { "color": "#388d35" }
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.includedIngredientsInfo')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _cache[5] || (_cache[5] = _createElementVNode("i", {
                                        class: "fas fa-plus",
                                        style: { "color": "#388d35" }
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.addModeDescription')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _cache[6] || (_cache[6] = _createElementVNode("i", {
                                        class: "fas fa-minus",
                                        style: { "color": "#ef4444" }
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.removeModeDescription')), 1)
                                ])
                            ]),
                            (additionalOptions.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("h4", _hoisted_18, _toDisplayString(_unref(t)('pos.additionalOptions')), 1),
                                    _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('pos.selectOneOption')), 1),
                                    _createElementVNode("div", _hoisted_20, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalOptions.value, (option) => {
                                            return (_openBlock(), _createElementBlock("label", {
                                                key: getOptionKey(option),
                                                class: _normalizeClass(["additional-option-card", { selected: isOptionSelected(option) }])
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: option,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedAdditionalOption).value = $event)),
                                                    class: "option-radio"
                                                }, null, 8, _hoisted_21), [
                                                    [_vModelRadio, selectedAdditionalOption.value]
                                                ]),
                                                _createElementVNode("span", _hoisted_22, _toDisplayString(getOptionName(option)), 1),
                                                _createElementVNode("i", {
                                                    class: _normalizeClass([
                                                        isOptionSelected(option)
                                                            ? 'fas fa-dot-circle'
                                                            : 'far fa-circle',
                                                        "option-icon"
                                                    ])
                                                }, null, 2)
                                            ], 2));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (baseIngredients.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseIngredients.value.filter((ing) => !removedBaseIngredients.value.has(ing.id)), (ingredient) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: ingredient.id,
                                                class: _normalizeClass([
                                                    'ingredient-card',
                                                    {
                                                        'default-ingredient': true,
                                                    },
                                                ]),
                                                style: { "cursor": "default" }
                                            }, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)),
                                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.included')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _createElementVNode("img", {
                                                        src: ingredient.imageUrl ||
                                                            ingredient.image ||
                                                            '/images/ingredients/default.png',
                                                        alt: ingredient.name
                                                    }, null, 8, _hoisted_27)
                                                ]),
                                                _createElementVNode("span", _hoisted_28, _toDisplayString(ingredient.name), 1),
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ingredient-price default-price" }, "Inclus", -1)),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        onClick: _withModifiers(($event) => (removeBaseIngredient(ingredient)), ["stop", "prevent"]),
                                                        class: "remove-base-btn",
                                                        title: "Retirer cet ingrédient"
                                                    }, [...(_cache[8] || (_cache[8] = [
                                                            _createTextVNode(" x ", -1),
                                                            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                        ]))], 8, _hoisted_30)
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedIngredients.value, (group) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: group.type,
                                        class: "ingredient-group"
                                    }, [
                                        _createElementVNode("h4", _hoisted_32, _toDisplayString(group.type), 1),
                                        _createElementVNode("div", _hoisted_33, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ingredients, (ingredient) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: ingredient.id,
                                                    class: _normalizeClass([
                                                        'ingredient-card',
                                                        {
                                                            'default-ingredient': ingredient.isDefault,
                                                            'removed-default': ingredient.isDefault &&
                                                                getIngredientQuantity(ingredient.id) === 0,
                                                            selected: getIngredientQuantity(ingredient.id) > 0,
                                                        },
                                                    ]),
                                                    onClick: ($event) => (toggleIngredient(ingredient))
                                                }, [
                                                    (ingredient.isDefault)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)),
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.included')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_36, [
                                                        _createElementVNode("img", {
                                                            src: ingredient.imageUrl ||
                                                                ingredient.image ||
                                                                '/images/ingredients/default.png',
                                                            alt: ingredient.name
                                                        }, null, 8, _hoisted_37),
                                                        (ingredient.isDefault &&
                                                            getIngredientQuantity(ingredient.id) === 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[11] || (_cache[11] = [
                                                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("span", _hoisted_39, _toDisplayString(ingredient.name), 1),
                                                    (ingredient.isDefault)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Inclus"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                                            (getIngredientPriceForSize(ingredient, selectedSize.value) > 0)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(" +" + _toDisplayString(formatPrice(getIngredientPriceForSize(ingredient, selectedSize.value))), 1)
                                                                ], 64))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createTextVNode(_toDisplayString(_unref(t)('pos.free')), 1)
                                                                ], 64))
                                                        ])),
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _createElementVNode("button", {
                                                            onClick: _withModifiers(($event) => (decrementIngredient(ingredient)), ["stop"]),
                                                            disabled: getIngredientQuantity(ingredient.id) <= 0,
                                                            style: { "display": "flex", "align-items": "center", "justify-content": "center", "width": "24px", "height": "24px", "border-radius": "50%", "color": "white", "font-size": "0.6rem", "font-weight": "600", "cursor": "pointer" }
                                                        }, " ➖ ", 8, _hoisted_43),
                                                        _createElementVNode("span", null, _toDisplayString(getIngredientQuantity(ingredient.id)), 1),
                                                        _createElementVNode("button", {
                                                            onClick: _withModifiers(($event) => (incrementIngredient(ingredient)), ["stop"]),
                                                            style: { "display": "flex", "align-items": "center", "justify-content": "center", "width": "24px", "height": "24px", "border-radius": "50%", "color": "white", "font-size": "0.6rem", "font-weight": "600", "cursor": "pointer" }
                                                        }, " ➕ ", 8, _hoisted_44)
                                                    ])
                                                ], 10, _hoisted_34));
                                            }), 128))
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "quantity-selector" }, null, -1)),
                            _createElementVNode("button", {
                                class: "add-to-cart-btn",
                                onClick: handleAddToCart
                            }, _toDisplayString(_unref(t)('pos.addToCart')) + " - " + _toDisplayString(formatPrice(totalPrice.value)), 1)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
